import client from '@/api/client';
import { BASE_URL } from '@/constants';
import { objectToQueryString } from '@/utils/sfaas_temp';

export default {
	async getCommCodes(codeType, plantCd) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${codeType}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async deletePartCkuMngList(delRows) {
		try {
			const response = await client.post(`${BASE_URL}/pqy/pcku/partCkuMng/v1/status/2/updateDelYn`, delRows);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getPartCkuMngList({ searchParams, pagingInfo }) {
		let queryStr = '';
		let partNo = searchParams.partNo;
		// let partNm = searchParams.partNm;
		// let currentPage = searchParams.currentPage;
		// let pageUnit = searchParams.pageUnit;
		if (searchParams.partNo !== undefined) {
			queryStr = objectToQueryString({
				partNo: partNo,
				partNm: searchParams.partNm,
				ckuNo: searchParams.ckuNo,
				cofCd: searchParams.cofCd,
				strDt: searchParams.strDt,
				endDt: searchParams.endDt,
				lotNo: searchParams.lotNo,
				lastYn: searchParams.lastYn,
				pgsStCd: searchParams.pgsStCd,
				orderNo: searchParams.orderNo,
				currentPage: pagingInfo.currentPage,
				pageUnit: pagingInfo.pageUnit
			});
		}
		try {
			const response = await client.get(`${BASE_URL}/pqy/pcku/partCkuMng/v1/ckuMngs${queryStr}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
